import { render, staticRenderFns } from "./user-configuration-print-tab-general.vue?vue&type=template&id=4f562201&scoped=true&"
import script from "./user-configuration-print-tab-general.ts?vue&type=script&lang=ts&"
export * from "./user-configuration-print-tab-general.ts?vue&type=script&lang=ts&"
import style0 from "./user-configuration-print-tab-general.scss?vue&type=style&index=0&id=4f562201&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f562201",
  null
  
)

export default component.exports